import React, { createContext, useState } from "react";

export const CompanyContext = createContext({
  companyId: "",
  repeatOnlyMissedQuestion: false,
  ssoFlg: false,
  setCompanyId: (companyId: string) => { },
  setRepeatOnlyMissed: (repeat: boolean) => { },
  setSsoFlg: (ssoFlg: boolean) => { },
  setCompanyState: (companyId: string, repeatOnlyMissedQuestion: boolean, ssoFlg: boolean) => { },
});

export const CompanyIdProvider = CompanyContext.Provider;
export const CompanyIdConsumer = CompanyContext.Consumer;

interface IProps {
  children: any;
}
export default function Company(props: IProps) {
  const [state, setState] = useState({
    companyId: "",
    repeatOnlyMissedQuestion: false,
    ssoFlg: false
  });

  function setCompanyId(companyId: string) {
    console.log("Company Context Update to ", companyId);
    setState({ ...state, companyId: companyId });
  }

  function setRepeatOnlyMissed(repeat: boolean) {
    setState({ ...state, repeatOnlyMissedQuestion: repeat });
  }

  function setSsoFlg(companyUsesSso: boolean) {
    setState({ ...state, ssoFlg: companyUsesSso });
  }

  function setCompanyState(
    companyId: string,
    repeatOnlyMissedQuestion: boolean,
    ssoFlg: boolean,
  ) {
    console.log(
      "Company Context Update to ",
      companyId,
      repeatOnlyMissedQuestion,
      ssoFlg,
    );
    setState({ companyId, repeatOnlyMissedQuestion, ssoFlg });
  }

  const userProviderValue = {
    ...state,
    setCompanyId: setCompanyId,
    setRepeatOnlyMissed: setRepeatOnlyMissed,
    setSsoFlg: setSsoFlg,
    setCompanyState: setCompanyState,
  };

  return (
    <CompanyIdProvider value={userProviderValue}>
      {props.children}
    </CompanyIdProvider>
  );
}
